export const compartir = function(url, text, title) {
	let shareData = {
		'url': url,
		'text': text,
		'title': title,
	};
	// Estándar indica que share solo funciona bajo https
	window.navigator.share(shareData);
};

export const puedeCompartir = function() {
	// A futuro reemplazar por window.navigator.canShare, que al momento (13-jul-2020) 
	// no está ampliamente implementado en los navegadores.
	let puede = (window.navigator.share !== undefined);
	return puede;
};